
import Vue, { PropType } from 'vue';
import Button from '~/components/builders/Base/Button.vue';
import Modal from '~/components/builders/Base/Modal.vue';
import { IProfileData } from '~/utils/user/validateCandidateData';
import MinimalProfileForm from '~/components/profile/forms/MinimalProfileForm.vue';
import { ProfileRequirementType } from '~/utils/candidate/CandidateProfileScorer';

interface DataType {
    isLoading: boolean;
    isFormValid: boolean;
    modalOpen: boolean;

    profileData: IProfileData | null;
}

export default Vue.extend({
    name: 'MinimalProfileModal',
    components: {
        Modal,
        Button,
        MinimalProfileForm,
    },
    props: {
        show: {
            type: Boolean,
            required: true,
        },
        type: {
            type: String as PropType<'register' | 'enter' | 'apply_job'>,
            required: true,
        },
        profileRequirementType: {
            type: String as PropType<ProfileRequirementType>,
            required: true,
        },
    },
    data(): DataType {
        return {
            isLoading: false,
            isFormValid: false,
            modalOpen: false,

            profileData: null,
        };
    },
    computed: {
        submitBtnText(): string {
            if (this.type === 'apply_job') return 'jobdetail.detailModule.apply';
            if (this.type === 'register') return 'vfair.profile.confirmRegister';
            if (this.type === 'enter') return 'vfair.profile.confirmEnter';
            return '';
        },
        title(): string {
            if (this.type === 'apply_job') return 'jobdetail.profile.headerApply';
            if (this.type === 'register') return 'vfair.profile.headerRegister';
            if (this.type === 'enter') return 'vfair.profile.headerEnter';
            return '';
        },
        description(): string {
            if (this.type === 'apply_job') return 'jobdetail.profile.applyDescription';
            if (this.type === 'register' || this.type === 'enter')
                return 'vfair.profile.description';
            return '';
        },
    },
    methods: {
        onValidateChange(isValid: boolean): void {
            this.isFormValid = isValid;
        },
        onLoadingChange(isLoading: boolean): void {
            this.isLoading = isLoading;
        },
        isValid(isValid: boolean): void {
            if (isValid) {
                this.$emit('valid', isValid);
                this.$emit('success');
            }
        },
        handleClose() {
            this.$emit('close');
        },
    },
    watch: {
        show(value: boolean) {
            if (value) {
                this.modalOpen = true;
            } else {
                this.modalOpen = false;
            }
        },
    },
});
